<template>
  <button v-if="!link" type="button" :class="buttonClass" @click="onClick">
    <div :class="containerClass">
      <span class="sr-only">{{ srOnlyDescription }}</span>
      <span :class="iconClass"></span>
    </div>
  </button>
  <a v-if="link" :href="link" :target="`${target ? target : '_self'}`" :class="buttonClass">
    <div :class="containerClass">
      <span class="sr-only">{{ srOnlyDescription }}</span>
      <span :class="iconClass"></span>
    </div>
  </a>
</template>
<script setup lang="ts">
import { defineEmits } from 'vue/dist/vue';

const emit = defineEmits(['onClick']);

const buttonClass =
  ' align-center block p-0 h-8 w-8 border border-[1.5px] rounded-[40px] border-solid border-racq-light-blue-grey active:border-racq-blue-active active:bg-racq-pale-grey active:bg-racq-white hover:bg-racq-pale-grey disabled:opacity-50 input-focus';

const iconClass = 'bg-icon-chevron icon w-[8.003px] h-[13.33px] bg-no-repeat bg-contain inline-block align-middle';

const containerClass = 'flex items-center justify-center w-8 h-8 shrink-0 aspect-square -mt-[1px]';

defineProps<{
  srOnlyDescription: string;
  link?: string;
  target?: string;
}>();

function onClick() {
  emit('onClick');
}
</script>
